import { Button } from "@/components/ui/button";
import { LucideTrash2 } from "lucide-react";
import { Modal } from "@/components/modals/Modal";

export function DeleteReportModal({ open, onClose, onConfirm, studentName, oen }) {
  const displayName = studentName?.trim() || null;
  const displayOen = oen?.trim() || null;

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Delete Report Card"
      subtitle="This action cannot be undone."
      icon={<LucideTrash2 size={16} className="text-destructive" />}
      maxWidth="max-w-sm"
    >
      <div className="px-6 py-5 space-y-4">
        <p className="text-sm text-muted-foreground">
          Are you sure you want to delete the report card for:
        </p>
        <div className="rounded-lg border border-border bg-muted/40 px-4 py-3 space-y-1">
          <p className="text-sm font-semibold text-foreground">
            {displayName ?? <span className="italic text-muted-foreground font-normal">Unnamed student</span>}
          </p>
          <p className="text-xs text-muted-foreground font-mono">
            {displayOen ?? <span className="italic not-italic font-sans">No OEN</span>}
          </p>
        </div>
        <div className="flex gap-2 pt-1">
          <Button variant="destructive" onClick={onConfirm}>
            Delete
          </Button>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
}
